import * as React from "react"
import { graphql } from "gatsby";
import Layout from "../components/includes/layout"
import Seo from "../components/includes/seo"
import { SliceZone } from "@prismicio/react";
import { components } from "../components/slices";

export const homeQuery = graphql`
query HomeQuery {
  prismicIndexPage(id: {eq: "b9ca242f-52ec-5d7a-9415-986d2edf33ad"}) {
    id
    _previewable
    data {
      body {
      ... on PrismicIndexPageDataBodyTextSlider {
              id
              items {
                label_text
                main_text
              }
              primary {
                background
                section_content {
                  richText
                }
                section_title {
                  richText
                }
                spacing
              }
              slice_type
            }
        ... on PrismicIndexPageDataBodySmallDetailCard {
          id
          slice_type
          primary {
            background
          }
          items {
            button_label
            card_hero_image {
              alt
              gatsbyImageData(layout: FULL_WIDTH)
            }
            card_logo {
              url
            }
            card_title {
              text
            }
            data_description
            data_point {
              text
            }
            link {
              url
            }
            theme
          }
        }
        ... on PrismicIndexPageDataBodyResults {
          id
          slice_type
          items {
            data_content
            data_point {
              text
            }
            theme
          }
          primary {
            background
            section_content {
              richText
            }
            section_title {
              richText
            }
            spacing
          }
        }
        ... on PrismicIndexPageDataBodyLargeDetailCard {
          id
          slice_type
          items {
            data_description
            data_point {
              text
            }
            theme
          }
          primary {
            background
            button_label
            card_hero_image {
              gatsbyImageData(layout: CONSTRAINED)
            }
            card_logo {
              url
            }
            card_title {
              text
            }
            link {
              url
            }
            spacing
          }
        }
        ... on PrismicIndexPageDataBodyCustom {
          id
          slice_type
          primary {
            code
          }
        }
        ... on PrismicIndexPageDataBodyTextBlockWithBg {
          id
          slice_type
          primary {
            background
            background_image {
              url
            }
            custom_html
            fade
            section_content {
              richText
            }
            section_title {
              richText
            }
            spacing
          }
        }
        ... on PrismicIndexPageDataBodyContentTabs {
          id
          slice_type
          items {
            button_label
            button_link {
              url
            }
            custom_html
            layout
            support_media
            video_animation {
              url
            }
            tab_content {
              richText
            }
            tab_image {
              gatsbyImageData(layout: CONSTRAINED)
              alt
            }
            tab_label
            tab_label_icon {
              url
            }
            tab_title {
              richText
            }
            theme
          }
          primary {
            background
            section_content {
              richText
            }
            section_title {
              richText
            }
            spacing
          }
        }
        ... on PrismicIndexPageDataBodyNavInsider {
          id
          slice_type
          primary {
            background
            spacing
            number_of_cards
          }
        }
        ... on PrismicIndexPageDataBodyTabs {
          id
          items {
            tab_label
            theme
            quotes {
              document {
                ... on PrismicQuoteSlider {
                  id
                  data {
                    quote {
                      author
                      author_title
                      content {
                        richText
                      }
                    }
                  }
                }
                ... on PrismicResource {
                  id
                  _previewable
                  data {
                    resource_type
                    resource_title {
                      richText
                    }
                    resource_label
                    description {
                      text
                    }
                    meta_image {
                      gatsbyImageData(layout: CONSTRAINED)
                      alt
                    }
                  }
                }
              }
            }
          }
          slice_type
          primary {
            background
            spacing
          }
        }
        ... on PrismicIndexPageDataBodyPressReleases {
          id
          slice_type
          primary {
            background
          }
        }
        ... on PrismicIndexPageDataBodyCard {
          id
          slice_type
          primary {
            background
            card_layout
            spacing
            card_slider
            section_title {
              richText
              text
            }
          }
          items {
            button_label
            card_content_type
            card_label
            resource_type
            custom_content
            custom_image {
              gatsbyImageData(layout: CONSTRAINED)
              alt
            }
            custom_title
            theme
            custom_link {
              url
              target
            }
            resource {
              type
              document {
                ... on PrismicNavigationInsider {
                  url
                  id
                  type
                  data {
                    resource_title {
                      richText
                    }
                    resource_label
                    date_published(formatString: "MMMM DD, YYYY")
                    description {
                      text
                    }
                    meta_image {
                      gatsbyImageData(layout: CONSTRAINED)
                      alt
                    }
                  }
                }
                ... on PrismicArticle {
                  id
                  url
                  type
                  data {
                    resource_title {
                      richText
                      text
                    }
                    resource_label
                    date_published(formatString: "MMMM DD, YYYY")
                    description {
                      text
                    }
                    meta_image {
                      gatsbyImageData(layout: CONSTRAINED)
                      alt
                    }
                  }
                }
                ... on PrismicResource {
                  id
                  url
                  _previewable
                  data {
                    resource_type
                    resource_title {
                      richText
                    }
                    resource_label
                    description {
                      text
                    }
                    meta_image {
                      gatsbyImageData(layout: CONSTRAINED)
                      alt
                    }
                  }
                }
              }
            }
            button_label
            card_label
            theme
          }
        }
        ... on PrismicIndexPageDataBodySideBySide {
          id
          items {
            button_color
            button_label
            button_link {
              url
              target
            }
            link_type
          }
          slice_type
          primary {
            card_resource {
              document {
                ... on PrismicResource {
                  id
                  url
                  data {
                    resource_title {
                      richText
                      text
                    }
                    resource_label
                    meta_image {
                      gatsbyImageData(layout: CONSTRAINED)
                      alt
                    }
                    resource_type
                    description {
                      text
                    }
                  }
                }
                ... on PrismicNavigationInsider {
                  id
                  url
                  data {
                    resource_title {
                      richText
                      text
                    }
                    resource_label
                    meta_image {
                      gatsbyImageData(layout: CONSTRAINED)
                      alt
                    }
                    description {
                      text
                    }
                  }
                }
                ... on PrismicPressRelease {
                  id
                  url
                  data {
                    resource_title {
                      richText
                      text
                    }
                    resource_label
                    meta_image {
                      gatsbyImageData(layout: CONSTRAINED)
                      alt
                    }
                    description {
                      text
                    }
                  }
                }
              }
            }
            background_image {
              url
            }
            fade
            background
            card_layout
            card_resource {
              url
            }
            card_resource_button_label
            content {
              text
              richText
            }
            content_color
            custom_html
            custom_code
            css_classes
            icon {
              alt
              dimensions {
                height
                width
              }
              gatsbyImageData(layout: CONSTRAINED, placeholder: NONE)
            }
            image {
              alt
              gatsbyImageData(layout: CONSTRAINED, placeholder: NONE)
            }
            label
            layout
            alignment
            quote_author
            quote_author_title
            quote_content {
              richText
            }
            support
            lottie_json
            video_animation {
              url
            }
            video_animation_hvec{
              url
            }
            box
            shadow
            box_background
            spacing
            theme
            title {
              richText
              text
            }
            video
          }
        }
        ... on PrismicIndexPageDataBodyTextBlock {
          id
          slice_type
          items {
            button_color
            button_link {
              url
            }
            label
          }
          primary {
            background
            block_content {
              richText
            }
            block_title {
              richText
              text
            }
            box
            icon{
              url
            }
            graphic{
              alt
              url
            }
            box_background
            border
            justify
            spacing
            theme
            width
          }
        }
        
      }
      hero_content {
        richText
      }
      description {
        text
      }
      video_animation{
        url
      }
      safari_hvec_video{
        url
      }
      video
      video_text
      cta {
        button_color
        label {
          text
        }
        button_link {
          url
        }
      }
      hero_title {
        text
        richText
      }
      meta_image {
        gatsbyImageData(placeholder: NONE)
        alt
        url
      }
      mobile_hero_image{
        gatsbyImageData(placeholder: NONE)
        alt
        url
      }
      page_title {
        text
      }
    }
  }
  prismicHeaderCallout {
    _previewable
    data {
      label {
        text
      }
      link {
        text
      }
      title {
        richText
      }
    }
  }
  prismicNavigation {
    _previewable
    id
    data {
      entry
      main_nav_items {
        nav_link {
          url
        }
        nav_label
        resource {
          document {
            ... on PrismicPressRelease {
              id
              data {
                resource_title {
                  text
                  richText
                }
                description {
                  text
                }
                meta_image {
                  gatsbyImageData
                  alt
                }
              }
              url
            }
            ... on PrismicResource {
              id
              data {
                resource_title {
                  text
                  richText
                }
                description {
                  text
                  
                }
                meta_image {
                  gatsbyImageData
                  alt
                }
              }
              url
            }
          }
        }
        drop_down {
          document {
            ... on PrismicNavigationItem {
              id
              data {
                theme
                sub_nav_item {
                  icon {
                    url
                    alt
                    gatsbyImageData(layout: CONSTRAINED)
                  }
                  nav_context{
                        text
                        richText
                      }
                  nav_label
                  sub_nav {
                    document {
                      ... on PrismicSubNavigationItem {
                        id
                        data {
                          sub_nav_item {
                            nav_label
                            nav_link {
                              url
                            }
                          }
                        }
                      }
                    }
                  }
                  nav_link {
                    url
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
`

const IndexPage = (props) => {

  return (
    <Layout page="home" video={props.data.prismicIndexPage.data.video_animation.url} hvec={props.data.prismicIndexPage.data.safari_hvec_video.url} heroTitle={props.data.prismicIndexPage.data.hero_title.richText} heroContent={props.data.prismicIndexPage.data.hero_content.richText} heroCTA={props.data.prismicIndexPage.data.cta} heroImage={props.data.prismicIndexPage.data.mobile_hero_image} headCall={props.data.prismicHeaderCallout.data} nav={props.data.prismicNavigation.data} vimeo={props.data.prismicIndexPage.data.video} videoText={props.data.prismicIndexPage.data.video_text}>
      <SliceZone slices={props.data.prismicIndexPage.data.body} components={components} />
    </Layout>
  )
}

export default IndexPage

export const Head = (props) => {

  const schema = {
    "@context": "https://schema.org",
    "@type": "Corporation",
    "name": "Quantum Health",
    "url": "https://quantum-health.com/",
    "logo": "https://images.prismic.io/qh-cs/12f9d237-19c9-492a-b642-5c042e71d9be_quantum-health-logo.png",
    "sameAs": [
      "https://www.facebook.com/QuantumHealth1/",
      "https://twitter.com/QuantumHealth1",
      "https://www.instagram.com/quantum_health/",
      "https://www.linkedin.com/company/quantum-health/"
    ],
    "contactPoint": [
      {
        "@type": "ContactPoint",
        "telephone": "(800) 257-2038",
        "contactType": "customer service",
        "contactOption": "TollFree",
        "areaServed": "US",
        "availableLanguage": ["en","es"]
      }
    ]
  }

  


return <Seo title={props.data.prismicIndexPage.data.page_title.text} desc={props.data.prismicIndexPage.data.description.text} metaImage={props.data.prismicIndexPage.data.meta_image.url} schemaMarkup={schema} url="" />

}

